import { Icon } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import styled from "styled-components";

import AppController from "js/core/AppController";
import { WhiteIconButton } from "js/react/components/UiComponents";
import { themeColors } from "js/react/sharedStyles";

const NotificationsLabelButton = styled(WhiteIconButton)`
    &&& {
        .MuiButtonBase-root {
            padding: 8px;
            position: relative;
    }

    span.countLabel {
        position: absolute;
        color: white;
        background-color: ${themeColors.ui_blue};
        border-radius: 80px;
        min-width: 8px;
        height: 14px;
        font-weight: 600;
        top: 8px;
        left: 23px;
        padding: 1px 4px;
        letter-spacing: 0px;
        font-size: 10px;
        display: flex;
        align-items: center;
        justify-content: center;

        &.small {
            font-size: 9px;
            line-height: 15px;
        }
    }

    .MuiIcon-root {
        padding: 8px;
        color: #fff;
        &:hover {
            color: #fff;
            background: rgba(255, 255, 255, 0.10);
            border-radius: 2px;
        }
    }   
}`;

export default function NotificationsLabel() {
    const [unreadCount, setUnreadCount] = useState(0);

    const handleUnreadChanged = () => {
        const count = AppController.notificationsService.unread
            .filter(notification => notification.event.workspaceId === AppController.workspaceId)
            .length;
        setUnreadCount(count);
    };

    useEffect(() => {
        handleUnreadChanged();
        AppController.notificationsService.onUnreadChanged(handleUnreadChanged);
        return () => {
            AppController.notificationsService.offUnreadChanged(handleUnreadChanged);
        };
    }, []);

    return (
        <NotificationsLabelButton onClick={() => AppController.showAccountPane({ pane: "notifications" })}>
            <Icon style={{ fontSize: 24 }}>notifications</Icon>
            {unreadCount > 0 && (
                <span className={`countLabel ${unreadCount > 99 ? "small" : ""}`}>
                    {unreadCount > 999 ? ">1k" : unreadCount}
                </span>
            )}
        </NotificationsLabelButton>
    );
}
